import Vue from 'vue'
import Router from 'vue-router'
import DoomyView from '../views/DoomyView'
import Login from '../views/Login'
import Page404 from '../views/Page404'
import Oauth from '../views/Oauth'
import Dashboard from '../views/Dashboard'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/404',
      name: '404',
      component: Page404
    },
    {
      path: '/oauth',
      name: 'oauth',
      component: Oauth
    },
    {
      path: '/direct/:hash',
      name: 'directDocument',
      component: () => import('../views/docflow/Direct')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('../views/docflow/Finder')
    },
    {
      path: '/docflow',
      component: DoomyView,
      beforeEnter: guardRoute,
      children: [
        {
          path: 'list',
          name: 'docflow',
          component: () => import('../views/docflow/List')
        },
        {
          path: 'incomingList',
          name: 'docflowIncoming',
          component: () => import('../views/docflow/IncomingList')
        },
        {
          path: 'appealsList',
          name: 'docflowAppeals',
          component: () => import('../views/docflow/AppealsList')
        },
        {
          path: 'outgoingList',
          name: 'docflowOutgoing',
          component: () => import('../views/docflow/OutgoingList')
        },
        {
          path: 'agreementsList',
          name: 'docflowAgreementsList',
          component: () => import('../views/docflow/AgreementsList')
        },
        {
          path: 'registrationsList',
          name: 'docflowRegistrationsList',
          component: () => import('../views/docflow/RegistrationsList')
        },
        {
          path: 'createIncoming',
          name: 'createIncomingDocflow',
          component: () => import('../views/docflow/CreateIncoming')
        },
        {
          path: 'createAppeal',
          name: 'createAppealDocflow',
          component: () => import('../views/docflow/CreateAppeal')
        },
        {
          path: 'detailIncoming/:documentId/:section?',
          name: 'docflowIncomingDetail',
          component: () => import('../views/docflow/IncomingDetail')
        },
        {
          path: 'detailAppeal/:documentId',
          name: 'docflowAppealDetail',
          component: () => import('../views/docflow/AppealDetail')
        },
        {
          path: 'createPlanGroup/:documentId',
          name: 'createPlanGroup',
          component: () => import('../views/docflow/CreatePlanGroup')
        },
        {
          path: 'editPlanGroup/:documentId/:groupId',
          name: 'editPlanGroup',
          component: () => import('../views/docflow/EditPlanGroup')
        },
        {
          path: 'editPlanItem/:documentId/:itemId',
          name: 'editPlanItem',
          component: () => import('../views/docflow/EditPlanItem')
        },
        {
          path: 'editPlanExecutors/:documentId/:itemId',
          name: 'editPlanExecutors',
          component: () => import('../views/docflow/EditPlanExecutors')
        },
        {
          path: 'createPlanItem/:documentId',
          name: 'createPlanItem',
          component: () => import('../views/docflow/CreatePlanItem')
        },
        {
          path: 'editIncoming/:documentId',
          name: 'editIncomingDocflow',
          component: () => import('../views/docflow/EditIncoming')
        },
        {
          path: 'editAppeal/:documentId',
          name: 'editAppealDocflow',
          component: () => import('../views/docflow/EditAppeal')
        },
        {
          path: 'createOutgoing',
          name: 'createOutgoingDocflow',
          component: () => import('../views/docflow/CreateOutgoing')
        },
        {
          path: 'editOutgoing/:documentId',
          name: 'editOutgoingDocflow',
          component: () => import('../views/docflow/EditOutgoing')
        },
        {
          path: 'detailOutgoing/:documentId/:section?',
          name: 'docflowOutgoingDetail',
          component: () => import('../views/docflow/OutgoingDetail')
        },
        {
          path: 'createResolution/:docType/:documentId',
          name: 'createResolution',
          component: () => import('../views/docflow/CreateResolution')
        },
        {
          path: 'editResolution/:docType/:documentId',
          name: 'editResolution',
          component: () => import('../views/docflow/EditResolution')
        },
        {
          path: 'docflowRegister/:documentId',
          name: 'docflowRegister',
          component: () => import('../views/docflow/Register')
        }
      ]
    },
    {
      path: '/workflow',
      component: DoomyView,
      beforeEnter: guardRoute,
      children: [
        {
          path: 'documents',
          name: 'documents',
          component: () => import('../views/workflow/Documents')
        },
        {
          path: 'tasks',
          name: 'tasks',
          component: () => import('../views/workflow/Tasks')
        },
        {
          path: 'createDocument',
          name: 'createDocument',
          component: () => import('../views/workflow/DocumentCreate')
        },
        {
          path: 'editDocument/:documentId',
          name: 'editDocument',
          component: () => import('../views/workflow/DocumentEdit')
        },
        {
          path: 'documentDetail/:documentId',
          name: 'documentDetail',
          component: () => import('../views/workflow/DocumentDetail')
        },
        {
          path: 'createTask/:documentId',
          name: 'createTask',
          component: () => import('../views/workflow/TaskCreate')
        },
        {
          path: 'editTask/:documentId/:taskId',
          name: 'editTask',
          component: () => import('../views/workflow/TaskEdit')
        },
        {
          path: 'taskDetail/:documentId/:taskId',
          name: 'taskDetail',
          component: () => import('../views/workflow/TaskDetail')
        },
      ]
    },
    {
      path: '/projectControl',
      component: DoomyView,
      beforeEnter: guardRoute,
      children: [
        {
          path: 'projects',
          name: 'projects',
          component: () => import('../views/projectControl/Projects')
        },
        {
          path: 'createProject',
          name: 'createProject',
          component: () => import('../views/projectControl/CreateProject')
        },
        {
          path: 'editProject/:projectId',
          name: 'editProject',
          component: () => import('../views/projectControl/EditProject')
        },
        {
          path: 'projectDetail/:projectId/:section?',
          name: 'projectDetail',
          component: () => import('../views/projectControl/ProjectDetail')
        },
        {
          path: 'createPhase/:projectId',
          name: 'createPhase',
          component: () => import('../views/projectControl/CreatePhase')
        },
        {
          path: 'editPhase/:projectId/:phaseId',
          name: 'editPhase',
          component: () => import('../views/projectControl/EditPhase')
        },
        {
          path: 'createFinancingSource/:projectId',
          name: 'createFinancingSource',
          component: () => import('../views/projectControl/CreateFinancingSource')
        },
        {
          path: 'editFinancingSource/:projectId/:financingSourceId',
          name: 'editFinancingSource',
          component: () => import('../views/projectControl/EditFinancingSource')
        },
        {
          path: 'createContractor/:projectId',
          name: 'createContractor',
          component: () => import('../views/projectControl/CreateContractor')
        },
        {
          path: 'editContractor/:projectId/:contractorId',
          name: 'editContractor',
          component: () => import('../views/projectControl/EditContractor')
        },
        {
          path: 'createSpending/:projectId',
          name: 'createSpending',
          component: () => import('../views/projectControl/CreateSpending')
        },
        {
          path: 'editSpending/:projectId/:spendingId',
          name: 'editSpending',
          component: () => import('../views/projectControl/EditSpending')
        },
        {
          path: 'createIssue/:projectId',
          name: 'createIssue',
          component: () => import('../views/projectControl/CreateIssue')
        },
        {
          path: 'editIssue/:projectId/:issueId',
          name: 'editIssue',
          component: () => import('../views/projectControl/EditIssue')
        },
      ]
    },
    {
      path: '/employees',
      component: DoomyView,
      beforeEnter: guardRoute,
      children: [
        {
          path: 'departments',
          name: 'departments',
          component: () => import('../views/employees/DepartmentsList')
        },
        {
          path: 'detail/:employeeId',
          name: 'employeeDetail',
          component: () => import('../views/employees/Detail')
        },
        {
          path: 'edit/:employeeId',
          name: 'editEmployeeData',
          component: () => import('../views/employees/EditData')
        },
        {
          path: 'changePassword',
          name: 'changePassword',
          component: () => import('../views/employees/ChangePassword')
        },
        {
          path: 'departmentDetail/:departmentId',
          name: 'departmentDetail',
          component: () => import('../views/employees/DepartmentDetail')
        }
      ]
    },
    {
      path: '/issueTracker',
      component: DoomyView,
      beforeEnter: guardRoute,
      children: [
        {
          path: 'issues',
          name: 'issues',
          component: () => import('../views/issueTracker/Issues')
        },
        {
          path: 'createIssueTracker',
          name: 'createIssueTracker',
          component: () => import('../views/issueTracker/CreateIssue')
        },
        {
          path: 'issueDetail/:issueId',
          name: 'issueDetail',
          component: () => import('../views/issueTracker/IssueDetail')
        },
        {
          path: 'editIssueTracker/:issueId',
          name: 'editIssueTracker',
          component: () => import('../views/issueTracker/EditIssue')
        }
      ]
    },
    {
      path: '/reports',
      component: DoomyView,
      beforeEnter: guardRoute,
      children: [
        {
          path: 'list',
          name: 'reportsList',
          component: () => import('../views/reports/List')
        },
        {
          path: 'user',
          name: 'userReport',
          component: () => import('../views/reports/UserReport')
        },
        {
          path: 'employeeExecutionReport',
          name: 'employeeExecutionReport',
          component: () => import('../views/reports/EmployeeExecutionReport')
        },
        {
          path: 'employeesOverdueDocumentsByRegisterBooks',
          name: 'employeesOverdueDocumentsByRegisterBooks',
          component: () => import('../views/reports/EmployeesOverdueDocumentsByRegisterBooksReport')
        },
        {
          path: 'shortBySenders',
          name: 'shortBySenders',
          component: () => import('../views/reports/ShortBySenders')
        },
        {
          path: 'expiringDocsByRegisterBooks',
          name: 'expiringDocsByRegisterBooks',
          component: () => import('../views/reports/ExpiringDocsByRegisterBooks')
        },
        {
          path: 'appealsByCategoriesAndRegions',
          name: 'appealsByCategoriesAndRegions',
          component: () => import('../views/reports/AppealsByCategoriesAndRegions')
        }
      ]
    },
    {
      path: '/analyticsDashboard',
      name: 'analyticsDashboard',
      component: () => import('../views/reports/AnalyticsDashboard'),
      beforeEnter: guardRoute
    },
    {
      path: '/globalSearch',
      name: 'globalSearch',
      component: () => import('../views/GlobalSearch'),
      beforeEnter: guardRoute
    },
    {
      path: '/surveys',
      component: DoomyView,
      beforeEnter: guardRoute,
      children: [
        {
          path: 'list',
          name: 'surveys',
          component: () => import('../views/survey/SurveyList')
        },
        {
          path: 'detail/:surveyId',
          name: 'surveyDetail',
          component: () => import('../views/survey/SurveyDetail')
        },
        {
          path: 'results/:surveyId',
          name: 'surveyResults',
          component: () => import('../views/survey/SurveyResults')
        },
        {
          path: 'create',
          name: 'createSurvey',
          component: () => import('../views/survey/CreateSurvey')
        },
        {
          path: 'edit/:surveyId',
          name: 'editSurvey',
          component: () => import('../views/survey/EditSurvey')
        }
      ]
    },
    {
      path: '/resources',
      component: DoomyView,
      beforeEnter: guardRoute,
      children: [
        {
          path: 'available',
          name: 'resources',
          component: () => import('../views/resources/ResourcesAvailable')
        },
        {
          path: 'reserve/:resourceId/:date',
          name: 'createReservation',
          component: () => import('../views/resources/CreateReservation')
        }
      ]
    },
    {
      path: '/announcement',
      component: DoomyView,
      beforeEnter: guardRoute,
      children: [
        {
          path: 'list',
          name: 'announcements',
          component: () => import('../views/announcements/List')
        },
        {
          path: 'create',
          name: 'createAnnouncement',
          component: () => import('../views/announcements/CreateAnnouncement')
        }
      ]
    },
    {
      path: '/moderator',
      component: DoomyView,
      beforeEnter: guardRoute,
      children: [
        {
          path: 'departments',
          name: 'manageDepartments',
          component: () => import('../views/moderator/DepartmentsList'),
        },
        {
          path: 'createDepartment',
          name: 'createDepartment',
          component: () => import('../views/moderator/DepartmentCreate')
        },
        {
          path: 'editDepartment/:id',
          name: 'editDepartment',
          component: () => import('../views/moderator/DepartmentEdit')
        },
        {
          path: 'positions',
          name: 'positions',
          component: () => import('../views/moderator/PositionsList'),
        },
        {
          path: 'createPosition',
          name: 'createPosition',
          component: () => import('../views/moderator/PositionCreate')
        },
        {
          path: 'editPosition/:id',
          name: 'editPosition',
          component: () => import('../views/moderator/PositionEdit')
        },
        {
          path: 'externalOrganizations',
          name: 'externalOrganizations',
          component: () => import('../views/moderator/ExternalOrganizationsList')
        },
        {
          path: 'createExternalOrganization',
          name: 'createExternalOrganization',
          component: () => import('../views/moderator/ExternalOrganizationCreate')
        },
        {
          path: 'editExternalOrganization/:id',
          name: 'editExternalOrganization',
          component: () => import('../views/moderator/ExternalOrganizationEdit')
        },
        {
          path: 'postNames',
          name: 'postNames',
          component: () => import('../views/moderator/PostNamesList')
        },
        {
          path: 'createPostName',
          name: 'createPostName',
          component: () => import('../views/moderator/PostNameCreate')
        },
        {
          path: 'editPostName/:id',
          name: 'editPostName',
          component: () => import('../views/moderator/PostNameEdit')
        },
        {
          path: 'registerBooks',
          name: 'registerBooks',
          component: () => import('../views/moderator/RegisterBooksList')
        },
        {
          path: 'createRegisterBook',
          name: 'createRegisterBook',
          component: () => import('../views/moderator/RegisterBookCreate')
        },
        {
          path: 'editRegisterBook/:id',
          name: 'editRegisterBook',
          component: () => import('../views/moderator/RegisterBookEdit')
        },
        {
          path: 'documentTypes',
          name: 'documentTypes',
          component: () => import('../views/moderator/DocumentTypesList')
        },
        {
          path: 'createDocumentType',
          name: 'createDocumentType',
          component: () => import('../views/moderator/DocumentTypeCreate')
        },
        {
          path: 'editDocumentType/:id',
          name: 'editDocumentType',
          component: () => import('../views/moderator/DocumentTypeEdit')
        },
        {
          path: 'deliveryTypes',
          name: 'deliveryTypes',
          component: () => import('../views/moderator/DeliveryTypesList')
        },
        {
          path: 'createDeliveryType',
          name: 'createDeliveryType',
          component: () => import('../views/moderator/DeliveryTypeCreate')
        },
        {
          path: 'editDeliveryType/:id',
          name: 'editDeliveryType',
          component: () => import('../views/moderator/DeliveryTypeEdit')
        },
        {
          path: 'resourceCategories',
          name: 'resourceCategories',
          component: () => import('../views/moderator/ResourceCategoriesList')
        },
        {
          path: 'createResourceCategory',
          name: 'createResourceCategory',
          component: () => import('../views/moderator/ResourceCategoryCreate')
        },
        {
          path: 'editResourceCategory/:id',
          name: 'editResourceCategory',
          component: () => import('../views/moderator/ResourceCategoryEdit')
        },
        {
          path: 'resources',
          name: 'manageResources',
          component: () => import('../views/moderator/ResourcesList')
        },
        {
          path: 'createResource',
          name: 'createResource',
          component: () => import('../views/moderator/ResourceCreate')
        },
        {
          path: 'editResource/:id',
          name: 'editResource',
          component: () => import('../views/moderator/ResourceEdit')
        },
        {
          path: 'employees',
          name: 'employees',
          component: () => import('../views/moderator/EmployeesList')
        },
        {
          path: 'createEmployee',
          name: 'createEmployee',
          component: () => import('../views/moderator/EmployeeCreate')
        },
        {
          path: 'editEmployee/:id',
          name: 'editEmployee',
          component: () => import('../views/moderator/EmployeeEdit')
        },
        {
          path: 'issueCategories',
          name: 'issueCategories',
          component: () => import('../views/moderator/IssueCategoriesList')
        },
        {
          path: 'createIssueCategory',
          name: 'createIssueCategory',
          component: () => import('../views/moderator/IssueCategoryCreate')
        },
        {
          path: 'editIssueCategory/:id',
          name: 'editIssueCategory',
          component: () => import('../views/moderator/IssueCategoryEdit')
        },
      ]
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: guardRoute
    },
    {
      path: '/dashboard/extended',
      name: 'extendedDashboard',
      beforeEnter: guardRoute,
      component: () => import('../views/ExtendedDashboard')
    }
  ]
})

function guardRoute(to, from, next) {
  const auth = router.app.$auth.isLoggedIn()

  if (auth) {
    next()
  } else {
    next({
      name: 'login'
    })
  }
}

export default router
